module.exports = __webpack_public_path__ + "media/images/error-404-page-099d14dc53906894c837f7cbb5c441f3.jpg";